export { default } from './svg/bookmark-star.svg';
